import { render, staticRenderFns } from "./RecipeAdd1.vue?vue&type=template&id=63a3acde&scoped=true&"
import script from "./RecipeAdd1.vue?vue&type=script&lang=js&"
export * from "./RecipeAdd1.vue?vue&type=script&lang=js&"
import style0 from "./RecipeAdd1.vue?vue&type=style&index=0&id=63a3acde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3acde",
  null
  
)

export default component.exports